const mapStyles = [
	{
		elementType: "labels",
		stylers: [
			{
				visibility: "on"
			}
		]
	},
	{
		featureType: "administrative",
		elementType: "geometry",
		stylers: [
			{
				visibility: "on"
			}
		]
	},
	{
		featureType: "administrative.land_parcel",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "administrative.neighborhood",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "poi",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "road",
		stylers: [
			{
				visibility: "on"
			}
		]
	},
	{
		featureType: "road",
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "transit",
		stylers: [
			{
				visibility: "off"
			}
		]
	}
];

export const loadDefaultStyle = map => {
	let styledMap = new window.google.maps.StyledMapType(mapStyles, {
		name: "Styled Map"
	});

	map.mapTypes.set("styled_map", styledMap);
	map.setMapTypeId("styled_map");
};

export const changePoiStyles = (map, poi_item) => {
	let style = {
		featureType: "poi."+poi_item.value,
		stylers: [{ visibility: poi_item.selected ? "on" : "off" }]
    };
    
    mapStyles.push(style);

	let styledMap = new window.google.maps.StyledMapType(mapStyles, {
		name: "Styled Map"
	});

	map.mapTypes.set("styled_map", styledMap);
	map.setMapTypeId("styled_map");
};



// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/handleMapStyles.js